import { Injectable } from '@angular/core';
import { ICommandHandler } from './command-handler-resolver.service';
import { Observable, of } from 'rxjs';
import { CommandBase, standardCommand } from '../../model/command';
import { NavigationService } from '../navigation.service';

@Injectable()
export class CreateCommandHandler implements ICommandHandler {
  constructor(private _navigation: NavigationService) {}

  canExecute(command: CommandBase): boolean {
    return command && command.id === standardCommand.create;
  }

  execute(command: CommandBase): Observable<void> {
    return of(this._navigation.navigateToForm());
  }
}
